import React, { useState, useMemo, useEffect } from "react";
import { toast } from "react-toastify";
import { connect, useSelector, useDispatch } from "react-redux";
import { Card, Accordion, Form, Row, Col } from "react-bootstrap";
import BooleanView from "./BooleanView";
import Select from "react-select";
import "./AssetView.scss";
import TutorialPopup from "../../help/TutorialPopup";
import { CHANGE_PAIR, CHANGE_STRATEGY } from "../../../actions/create-bot-type";
import { BotType, StrategyModule } from "../../../Const";
import { getBalance, getPairBalance } from "../../../actions/bot-action";
import { Trans } from "react-i18next";
import SymbolSearchBox from "./modules/SymbolSearchBox";
import LeftRightForm from "./modules/LeftRightForm";
import BotTitle from "./modules/BotTitle";

const AssetView = (props) => {
  const { newBot,getBalance,getPairBalance,t ,step} = props;
  const MARGIN_SHORT_EXCHANGE_IDS = [17,12, 18,1,100];
  const strategy = newBot.strategy;
  const dispatch = useDispatch();
  const selectedExchange = newBot.exchange;
  const pair = newBot.pair;
  const selectedPair = pair && {
    value: newBot.exchangePairId,
    label: `${pair.from}/${pair.to} ${newBot.isCrypto==1?"(Crypto)":""}`,
    from: pair.from,
    to: pair.to,
    is247: newBot.is_247,
    isCrypto: newBot.isCrypto,
  } || {};


  const handleSelectPair = (item) => {
    getBalance(selectedExchange.id)
    const newPair = item || {};
    getPairBalance(selectedExchange.id,newPair.pair_id,'spot');
    dispatch({
      type: CHANGE_PAIR,
      payload: newPair,
    });
  };

  const handleNext = () => {
    if (!newBot.pair) {
      toast.warn(t("pls-select-stock-symbol"));
      return;
    }
    step('next');
  };
  useEffect(() => {
    getBalance(selectedExchange.id)
    //getPairBalance(selectedExchange.id,pair.id,'spot');
  }, [selectedExchange.id]);

  const strategyChanged = (strategy) => {
    dispatch({
      type: CHANGE_STRATEGY,
      payload: strategy,
    });
  };
  useEffect(() => {
    if(selectedExchange.id ==18 && strategy=="Short"){
      strategyChanged("Margin Short")
    }
  }, [strategy]);

  const descriptions = {
    quick_start: t("quick_start-description"),
    simple: t("simple-description"),
    advance: t("advance-description"),
    dca: t("dca-description"),
    exit: t("exit-description"),
    price: t("price-description"),
    grid: t("grid-description"),
    sell: t("sell-description"),
    momentum: t("momentum-description"),
  };

  return (
    <div className="d-flex">
      {newBot.botType != 'quick_start' && <div className="bot-description-text">
        <p dangerouslySetInnerHTML={{ __html: descriptions[newBot.botType] }}></p>
      </div>}
    <div className={`${newBot.botType != 'quick_start' ? 'asset-view-page ba-asset-form-content pos-relative' : ' ba-asset-form-content pos-relative'}`}>
     
      <div className="row gx-0 gy-3">
          <BotTitle></BotTitle>
          <div className="cb-form-div">
          <div className="col-lg-4">
              <div className="ba-asset-left">
                <h6>
                {t("exchange")} <TutorialPopup content={t("exchange-help")} />
                </h6>
                </div>
            </div>
            <div className="col-lg-8">
              <div className="ba-asset-right">
                  <img
                    src={selectedExchange.id==0?"/images/icon-paper.svg":selectedExchange.image}
                    width={20}
                    height={20}
                    className={selectedExchange.id==0?"paper_exchange":""}
                    style={{ marginRight: 10 }}
                  />
                  <span style={{ fontWeight: "bold", fontSize: 16 }}>
                    {selectedExchange.name}
                  </span>
                </div>
             </div>
             </div>
             <div className="cb-form-div">
             <div className="col-lg-4">
                <div className="ba-asset-left">
                  <h6>
                    {t("t-pair")} <TutorialPopup content={t("tradingpair-help")} />
                  </h6>
                  </div>
              </div>
              <div className="col-lg-8">
                  <div className="ba-asset-right">
                   <SymbolSearchBox selectedExchange={selectedExchange} selected={handleSelectPair} selectedPair={selectedPair}></SymbolSearchBox>
                  </div>
                  <span className="mt-2">
                    <Trans i18nKey={'miss-pair-note'}><a className="link" href="/setting?loc=8"></a></Trans>
                  </span>
              </div>
              </div>
          {(!MARGIN_SHORT_EXCHANGE_IDS.includes(selectedExchange.id)) ? <>
            {(StrategyModule[newBot.botType]) && (
                <BooleanView
                  title={`Strategy`}
                  firstButton="Long"
                  secondButton="Short"
                  selected={newBot.strategy}
                  onSelect={strategyChanged}
                  tutorial={<TutorialPopup content={t("strategy-help")} />}
                />
            )}
            </>:<>
            <LeftRightForm
              left={<>  <Form.Label className="bot-asset-tour">
              {t("Strategy")} <TutorialPopup content={t("strategy-help")} />
            </Form.Label></>}
              right={<> <div className="ba-asset-Strategy-btn">
                
              <a
               className={strategy == "Long" ?"success selected" : ""}
               onClick={() => strategyChanged("Long")}
             >
               LONG
             </a>
             <a 
               className={strategy == "Short" ?"danger selected" : ""}
               onClick={() => strategyChanged("Short")}
             >
               SHORT
             </a>
             <a
               className={strategy == "Margin Short" ?"danger selected" : ""}
               onClick={() => strategyChanged("Margin Short")}
             >
               MARGIN SHORT
             </a>
           </div>
              </>}
            ></LeftRightForm> </> }
            <div className="col-lg-12">
                <div className="bas-asset-submit bas-asset-btn2">
                  <button onClick={handleNext}>Next</button>
                </div>
              </div>
      </div>
          
          
    </div>
    </div>
  );
};

export default connect(null,{getBalance,getPairBalance})(AssetView);
